export { default as InducteeInductionHero } from './InducteeInductionHero';